import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  appData: {
    targetsmiles: '',
    smiles: '',
    pdb: '',
    library: '',
    method: '',
    userId: '',
  },
}

export const appDataSlice = createSlice({
  name: 'appData',
  initialState,
  reducers: {
    setAppData: (state, action) => {
      state.appData = {
        ...state.appData,
        ...action.payload
      }
    },
  },
})

export const { setAppData } = appDataSlice.actions

export default appDataSlice.reducer
